import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import { formataUrlBase, validaSite } from '@/shared/common/functions/roteamento'
import { validaAutenticacao } from '@/shared/common/functions/autenticacao'
import { inicializaTema, suspendeTemaNoDocumento } from '@/shared/common/functions/tema'
import { aplicaVersaoAppDaUrl, aplicaVersaoAppPendente } from '@/shared/common/functions/ambiente'
import { insereNovidades } from '@/shared/plugins/novidades'
import loading from '@/shared/plugins/loading'
import store from '@/shared/store'

Vue.use(VueRouter)
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to) {
        if(to.meta && to.meta.disableScrollTop){
            return false
        }
        document.getElementById('app').scrollIntoView({
            behavior: "smooth"
        });
    }
})

// Troca de ambiente via ?versao_app= — roda aqui (e não no main.js) porque o
// router compartilhado é carregado por todos os builds, inclusive os módulos
aplicaVersaoAppDaUrl()

// Tela servida pelo servidor da loja (o app do PDV entrega a página no endereço dele, na rede da
// loja). Ali não existe sessão do ERP: quem identifica o operador é o app, com nome + PIN. Então
// qualquer caminho que levaria ao login — a raiz ou o próprio /login — vai para a tela do servidor.
// Fora dessa origem `window.__PDV_SERVIDOR__` não existe e nada aqui muda.
const TELA_SERVIDOR_LOJA = '/pedidos/vendas/vendas_balcao/servidor'

const servidoPeloAppDaLoja = () => {
    try {
        return !!window.__PDV_SERVIDOR__
    } catch (erro) {
        return false
    }
}

router.beforeEach(async (to, from, next) => {

    if (servidoPeloAppDaLoja() && (to.path == '/' || /\/login\/?$/.test(to.path))) {
        return next(TELA_SERVIDOR_LOJA)
    }

    if (aplicaVersaoAppPendente(router.resolve(to.fullPath).href)) {
        return
    }

    // Revalida o domínio (white label) a cada navegação: sem isso uma aba
    // aberta ficaria com o chat/tema antigo até o F5. Com cache válido não há
    // requisição; mudou → recarrega já na rota de destino. O primeiro load
    // fica com o App.vue (domínio ainda vazio aqui).
    if (store.state.dominios.dominio) {
        const dominio = await store.dispatch('dominios/carregaDominio')
        if (dominio && dominio.recarregar) {
            window.location.href = router.resolve(to.fullPath).href
            return
        }
    }

    insereNovidades(to.path)
    formataUrlBase(to.fullPath)

    // Tema escuro só nas telas internas; login, cadastro e impressão (public)
    // e telas marcadas com meta.temaClaro (layout de login, ex.: redefinir
    // senha) ficam claras por decisão de design (fundacoes.md). A preferência
    // salva não muda, só sai da página.
    if (to.meta.public || to.meta.temaClaro) {
        suspendeTemaNoDocumento()
    } else {
        inicializaTema()
    }

    if (to.path === '/') {
        loading.show()
        const possuiSite = await validaSite()
        if (possuiSite) {
            return window.location.href = '/site'
        } else {
            const isAutenticado = await validaAutenticacao()
            if (!isAutenticado) {
                return window.location.href = '/login'
            }else{
                if (aplicaVersaoAppPendente('/inicio')) {
                    return
                }
                return window.location.href = '/inicio'
            }
        }
    }

    if (!to.meta.public) {
        loading.show()
        const isAutenticado = await validaAutenticacao()
        if (!isAutenticado) {
            return window.location.href = Vue.prototype.$urlBase + '/login'
        }
        // A resposta do verifica_autenticacao já trouxe o x-versao-app: se o
        // ambiente mudou, troca agora (ainda na navegação, sem tela aberta)
        if (aplicaVersaoAppPendente(router.resolve(to.fullPath).href)) {
            return
        }
        loading.hide()
    }

    next()
})

export default router
